import Navigation from "./Navigation";
import SeasonTheme from "./SeasonContext";

const Context = {
  SeasonTheme,
  Navigation,
};

export default Context;
